import React from 'react'

const SvgUnmuted = (props: React.SVGAttributes<SVGElement>) => (
  <svg width='2em' height='2em' viewBox='0 0 24 24' fill='none' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.563 5.319A.75.75 0 0112 6v12a.75.75 0 01-1.238.57l-2.79-2.391H5.25a.75.75 0 01-.75-.75V8.57a.75.75 0 01.75-.75h2.723l2.789-2.39a.75.75 0 01.801-.112zM10.5 7.63L8.738 9.14a.75.75 0 01-.488.18H6v5.358h2.25a.75.75 0 01.488.18l1.762 1.51V7.631zM14.698 9.25a.75.75 0 01.989.386c.303.691.438 1.547.438 2.364s-.135 1.673-.438 2.364a.75.75 0 01-1.374-.603c.197-.448.312-1.085.312-1.761 0-.676-.115-1.313-.312-1.761a.75.75 0 01.385-.988zM17.645 7.964a.75.75 0 011.016.306c.573 1.069.839 2.42.839 3.73s-.266 2.661-.84 3.73a.75.75 0 01-1.321-.71c.427-.795.66-1.887.66-3.02s-.233-2.225-.66-3.02a.75.75 0 01.306-1.016z'
      fill='currentColor'
    />
  </svg>
)

export default SvgUnmuted
